export default __webpack_public_path__ + "static/media/gallery_04.6b3aab75.jpg";